import { useContext } from 'react'
import {
  SessionStatus,
  SessionStatusContext,
} from 'src/context/SessionStatusProvider/SessionStatusProvider'

/** Read the authenticated-session status from SessionStatusProvider. */
export const useSessionStatus = (): SessionStatus => {
  const ctx = useContext(SessionStatusContext)
  if (ctx === undefined) {
    throw new Error(
      'useSessionStatus must be used within a SessionStatusProvider',
    )
  }
  return ctx
}
